import { cx } from "@/lib/cx";

// Loaded here rather than in a barrel because features import these components
// by path; `surface.ts` is the one module every overlay file already depends on,
// so importing it once here guarantees the keyframes exist wherever an overlay
// is used. Vite dedupes the import.
import "./overlay.css";

/**
 * Shared overlay structure. Surface colour and radius live here; each floating
 * primitive owns the elevation appropriate to its role: pop/dialog use
 * shadow-pop, Peek uses shadow-sheet, and a carried card uses shadow-drag.
 */

/** Z layers, in one place so "which one is on top" is a fact, not a guess. */
export const LAYER = {
  /** The peek. Below everything modal, because it is not modal. */
  peek: "z-40",
  /** Dialogs and every popper. A popper opened from inside a dialog portals
      later in the DOM, so equal z-index still lands it on top. */
  overlay: "z-50",
  /** The card/row a finger is currently carrying. Above the peek, because a
      board can be dragged while a card panel is open; level with the overlay
      layer, because nothing modal can be open at the same time as a drag. */
  drag: "z-50",
  /** Toasts, which must stay readable over a dialog and over the peek. */
  toast: "z-[60]",
} as const;

/**
 * The shared structural skin for Dialog and Peek: one opaque overlay material
 * and the 12px surface radius. Shadow is deliberately absent here because the
 * caller decides whether it is a floating dialog (shadow-pop) or a persistent
 * peek panel (shadow-sheet).
 */
export const sheetSurface = cx(
  "busee-sheet flex flex-col overflow-hidden rounded-surface border-2 border-ps1-orange bg-overlay-panel text-ink",
);
